import api from 'app/api';
import store from 'app/store';

export const createCity = async (payload, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.post(
    `/venues/city`,
    payload,
    {
      id: 'create-city',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const deleteCity = async (id, callback = () => null) => {
  await api.delete(
    `/venues/city/${id}`,
    {
      id: 'delete',
      success: {
        callback: callback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const getCityList = async (callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'ADMIN_CITY_LIST:CITY_LIST:SET', data: (data || []).map((item) => ({ ...item, id: item?._id, label: item?.cityName })) });

    if (callback) callback(data);
  };

  await api.get(
    `/venues/city`,
    {
      id: 'list-cities',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        isAdmin: true,
      },
    },
  );
};
